import { render } from "./AboutPage.vue?vue&type=template&id=0d0e47cf&scoped=true&hidden=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=0d0e47cf&lang=scss&scoped=true"

import exportComponent from "/Users/jamesedgeworth/Sites/je-vue/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0e47cf"]])

export default __exports__